import PropTypes from "prop-types";
import TableHead from "@material-ui/core/TableHead";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";

const headCells = [
  { id: "correlativo", numeric: true, disablePadding: true, label: "N", sorteable: false, witdh: '100px' },
  {
    id: "modificado",
    numeric: false,
    disablePadding: true,
    label: "MODIFICADO",
    sorteable: true,
    width: "160px"
  },
  { id: "fecha", numeric: false, disablePadding: true, label: "FECHA", sorteable: true, width: "90px" },
  { id: "nit", numeric: false, disablePadding: true, label: "NIT/CI", sorteable: false, width: "100px" },
  { id: "exp", numeric: false, disablePadding: true, label: "EXP", sorteable: false, width: "50px" },
  {
    id: "razon_social",
    numeric: false,
    disablePadding: true,
    label: "RAZON SOCIAL",
    sorteable: false,
    width: "250px"
  },
  {
    id: "autorizacion",
    numeric: true,
    disablePadding: true,
    label: "N AUTORIZACIÓN",
    sorteable: false,
    width: "200px"
  },
  { id: "factura", numeric: true, disablePadding: true, label: "N FACTURA", sorteable: false, width: "100px" },
  {
    id: "importe",
    numeric: false,
    disablePadding: true,
    label: "IMPORTE TOTAL",
    sorteable: false,
    width: "100px"
  },
  { id: "ice", numeric: false, disablePadding: true, label: "ICE", sorteable: false, width: "100px" },
  { id: "iehd", numeric: false, disablePadding: true, label: "IEHD", sorteable: false, width: "100px" },
  { id: "ipj", numeric: false, disablePadding: true, label: "IPJ", sorteable: false, width: "100px" },
  { id: "tasas", numeric: false, disablePadding: true, label: "TASAS", sorteable: false, width: "100px" },
  {
    id: "otros_no_cfiva",
    numeric: false,
    disablePadding: true,
    label: "NO SUJETO CFIVA",
    sorteable: false,
    width: "100px"
  },
  { id: "exportaciones", numeric: false, disablePadding: true, label: "EXPORT", sorteable: false, width: "100px" },
  { id: "tasa_cero", numeric: false, disablePadding: true, label: "TASA CERO", sorteable: false, width: "100px" },
  { id: "subtotal", numeric: false, disablePadding: true, label: "SUBTOTAL", sorteable: false, width: "100px" },
  {
    id: "descuentos",
    numeric: false,
    disablePadding: true,
    label: "DESCUENTOS",
    sorteable: false,
    width: "100px"
  },
  { id: "gift_card", numeric: false, disablePadding: true, label: "GIFT CARD", sorteable: false, width: "100px" },
  {
    id: "base_dfiva",
    numeric: false,
    disablePadding: true,
    label: "BASE DFIVA",
    sorteable: false,
    width: "100px"
  },
  { id: "dfiva", numeric: false, disablePadding: true, label: "DFIVA", sorteable: false, width: "100px" },
  {
    id: "tipo_venta",
    numeric: false,
    disablePadding: true,
    label: "TIPO VENTA",
    sorteable: false,
    width: "100px"
  },
  {
    id: "estado",
    numeric: false,
    disablePadding: true,
    label: "ESTADO",
    sorteable: false,
    width: "100px"
  },
  {
    id: "codigo_control",
    numeric: false,
    disablePadding: true,
    label: "CODIGO CONTROL",
    sorteable: false,
    width: "200px"
  },
  {
    id: "actions",
    numeric: false,
    disablePadding: true,
    label: "ACCIONES",
    sorteable: false,
    width: "140px"
  },
];


function HeaderVentas(props) {
  const { classes, order, orderBy, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          headCell.sorteable ?
            <TableCell
              key={headCell.id}
              align="center"
              width={headCell.width}
              padding={headCell.disablePadding ? "none" : "normal"}
              sortDirection={orderBy === headCell.id ? order : false}
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                onClick={createSortHandler(headCell.id)}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <span className={classes.visuallyHidden}>
                    {order === "desc" ? "sorted descending" : "sorted ascending"}
                  </span>
                ) : null}
              </TableSortLabel>
            </TableCell> : <TableCell
              key={headCell.id}
              width={headCell.width}
              align="center"
              padding={headCell.disablePadding ? "none" : "normal"}
            >{headCell.label}</TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

HeaderVentas.propTypes = {
  classes: PropTypes.object.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

export default HeaderVentas;